import { Filters } from './Filters';
import { Grid } from './Grid';
import { Header } from './Header';
import { Content, GridContainer } from './styled';
export function ComposerSelect() {
    return (<Content>
      <Filters />
      <GridContainer>
        <Header />
        <Grid />
      </GridContainer>
    </Content>);
}
